import { component } from 'picoapp'
import { zelektor, setCookie, getCookie, renderProductCard } from '@/lib/utility-functions.js'

export default component((node,ctx) => {
    /*******************************************************************************************************************************************/
    /* Data + Elements
    /*******************************************************************************************************************************************/
    const { list } = zelektor(node)
    const { currentId, limit } = node.dataset
    let cookie = getCookie('recently_viewed')


    /*******************************************************************************************************************************************/
    /* Cookie + Product IDs
    /*******************************************************************************************************************************************/
    if (!cookie) setCookie('recently_viewed', `${currentId}`, 10)
    else if (!cookie.includes(currentId)) setCookie('recently_viewed', `${cookie},${currentId}`, 10)
    cookie = getCookie('recently_viewed')

    const productIDs = cookie.replace(currentId, '').split(',').filter(val => val != '').reverse()
    productIDs.length ? getProducts(productIDs) : node.remove()


    /*******************************************************************************************************************************************/
    /* Get Products
    /*******************************************************************************************************************************************/
    function getProducts(productIDs) {
        fetch(`https://middleman.app.grafikrdev.dk/${Shopify.shop.replace('.myshopify.com','')}/products?ids=${productIDs.join(',')}&limit=${limit}`)
        .then(r => r.json())
        .then(json => {
            const products = json.data.products
            const availableProducts = products.filter(p => p.variants.find(v => v.inventory_quantity > 0))
            renderProducts(availableProducts)
        })
    }

    function renderProducts(products) {
        products.forEach(product => {
            const item = document.createElement('div')
            item.classList.add('grid__item')
            list.appendChild(item)

            renderProductCard({ product, parentEl: item, middleMan: true })
        })
    }
})